import { render, staticRenderFns } from "./guidePopup.vue?vue&type=template&id=3946a0f4&scoped=true"
import script from "./guidePopup.vue?vue&type=script&lang=js"
export * from "./guidePopup.vue?vue&type=script&lang=js"
import style0 from "./guidePopup.vue?vue&type=style&index=0&id=3946a0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946a0f4",
  null
  
)

export default component.exports